import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider, SelectNonceProvider } from '@dexma/ui-components';
import styled, { StyleSheetManager } from 'styled-components';
import { BrowserRouter as Router } from 'react-router-dom';
import crossFetch from 'cross-fetch';
import { datadogLogs } from '@datadog/browser-logs';
import { initReactI18next } from 'react-i18next';

import getDataDogConfig from 'adapter/in/dashboards/config/datadog';
import { log } from 'adapter/in/common/config/pino';

import i18n from 'asset/translation';

import httpClient from 'adapter/in/common/utils/httpClient';
import App from 'adapter/in/dashboards/app';

// TODO check better approach for different ports in local (json-server) than in pre/prod
if (!process.env.ENV) {
    throw new Error();
}

let port: number;
let apiPrefix: string;
let pathUrl: string;

if (process.env.ENV === 'DEVELOPMENT') {
    port = 4000;
    apiPrefix = '';
    pathUrl = '';
} else {
    port = 80;
    apiPrefix = '/api-v3';
    pathUrl = 'dashboardsv2/';
    datadogLogs.init(getDataDogConfig());
}

i18n.use(initReactI18next);
log.info(`Welcome to ${process.env.NAME} ${VERSION}`);

const fetch = httpClient(crossFetch, window.location.search);

const host = document.querySelector<HTMLElement>('#dashboards') as HTMLElement;

const styleSlot = host.querySelector('#dashboards-root') as HTMLElement;
const renderIn = host.querySelector('#dashboards-slot') as HTMLElement;

const StyledApp = styled.div`
    height: 100%;

    & > div:first-child {
        height: 100%;
    }
`;

ReactDOM.render(
    <>
        <StyleSheetManager target={styleSlot}>
            <StyledApp>
                <ConfigProvider getPopupContainer={() => styleSlot}>
                    <SelectNonceProvider container={styleSlot}>
                        <Router basename='/'>
                            <App port={port} apiPrefix={apiPrefix} pathUrl={pathUrl} fetch={fetch} />
                        </Router>
                    </SelectNonceProvider>
                </ConfigProvider>
            </StyledApp>
        </StyleSheetManager>
    </>,
    renderIn
);
